import { Printdata } from '@/modules/ewerp/models/PrintdataModels';

export type State = {
  printdata: Array<Printdata>;
};

export const state: State = {
  printdata:
    sessionStorage.getItem('printdata') != null && sessionStorage.getItem('printdata') !== undefined
      ? JSON.parse(sessionStorage.printdata)
      : new Array<Printdata>(),
};
